import React, { Component } from 'react';
import { Button, Grid, Header, Popup, Segment, Table } from 'semantic-ui-react';
import PropertyForm from '../PropertyForm';
import { checkWritePrivilege } from '../../util/util';

const v = (val) => val != null && val !== '' ? val : '-';

class Info extends Component {
    constructor(props) {
        super(props);
        this.state = {
            editing: false,
        };
    }

    render() {
        const {
            orgUnitProperty,
            onRefresh
        } = this.props;
        const { editing } = this.state;
        const prop = orgUnitProperty.property || {};
        const address = prop.address || {};
        const place = address.place || {};

        if (editing) {
            return (
                <PropertyForm
                    organizationalUnitProperty={orgUnitProperty}
                    onCloseForm={() => this.setState({ editing: false })}
                    onRefreshData={onRefresh}
                />
            );
        }

        return (
            <div>
                <Header as="h3">
                    <Header.Content style={{
                        display: 'flex',
                        justifyContent: 'space-between'
                    }}>
                        <div></div>
                        {checkWritePrivilege() &&
                            <Popup
                                content="Uredi podatke"
                                position="top center"
                                trigger={
                                    <Button
                                        icon="pencil"
                                        circular
                                        basic
                                        color="green"
                                        size="mini"
                                        onClick={() => this.setState({ editing: true })}
                                    />
                                }
                            />
                        }
                    </Header.Content>
                </Header>
                <Grid columns={2}>
                    <Grid.Column>
                        {/* Opći podaci */}
                        <Segment>
                            <Header as="h4">Opći podaci</Header>
                            <Table basic="very" compact celled>
                                <Table.Body>
                                    <Table.Row>
                                        <Table.Cell textAlign="right"
                                                    style={{ fontWeight: 'bold' }}>Članica</Table.Cell>
                                        <Table.Cell>{orgUnitProperty.organizationalUnit ? orgUnitProperty.organizationalUnit.name : '-'}</Table.Cell>
                                    </Table.Row>
                                    <Table.Row>
                                        <Table.Cell textAlign="right" style={{ fontWeight: 'bold' }}>Naziv
                                            imovine</Table.Cell>
                                        <Table.Cell>{v(prop.name)}</Table.Cell>
                                    </Table.Row>
                                    <Table.Row>
                                        <Table.Cell textAlign="right" style={{ fontWeight: 'bold' }}>Tip
                                            imovine</Table.Cell>
                                        <Table.Cell>{prop.propertyType ? prop.propertyType.name : '-'}</Table.Cell>
                                    </Table.Row>
                                    <Table.Row>
                                        <Table.Cell textAlign="right" style={{ fontWeight: 'bold' }}>Ulica</Table.Cell>
                                        <Table.Cell>{v(address.street)}</Table.Cell>
                                    </Table.Row>
                                    <Table.Row>
                                        <Table.Cell textAlign="right" style={{ fontWeight: 'bold' }}>Mjesto</Table.Cell>
                                        <Table.Cell>{v(place.name)}</Table.Cell>
                                    </Table.Row>
                                    <Table.Row>
                                        <Table.Cell textAlign="right"
                                                    style={{ fontWeight: 'bold' }}>Opština</Table.Cell>
                                        <Table.Cell>{place.municipality ? place.municipality.name : '-'}</Table.Cell>
                                    </Table.Row>
                                    <Table.Row>
                                        <Table.Cell textAlign="right" style={{ fontWeight: 'bold' }}>Kanton</Table.Cell>
                                        <Table.Cell>{place.canton ? place.canton.name : '-'}</Table.Cell>
                                    </Table.Row>
                                    <Table.Row>
                                        <Table.Cell textAlign="right"
                                                    style={{ fontWeight: 'bold' }}>Entitet</Table.Cell>
                                        <Table.Cell>{place.entity ? place.entity.name : '-'}</Table.Cell>
                                    </Table.Row>
                                    <Table.Row>
                                        <Table.Cell textAlign="right" style={{ fontWeight: 'bold' }}>Država</Table.Cell>
                                        <Table.Cell>{place.country ? place.country.name : '-'}</Table.Cell>
                                    </Table.Row>
                                </Table.Body>
                            </Table>
                        </Segment>

                        {/* Usklađenost */}
                        <Segment>
                            <Header as="h4">Usklađenost</Header>
                            <Table basic="very" compact celled>
                                <Table.Body>
                                    <Table.Row>
                                        <Table.Cell textAlign="right"
                                                    style={{ fontWeight: 'bold' }}>Usklađeno</Table.Cell>
                                        <Table.Cell>{prop.harmonized ? 'Da' : 'Ne'}</Table.Cell>
                                    </Table.Row>
                                </Table.Body>
                            </Table>
                        </Segment>

                        {/* Dokazi */}
                        <Segment>
                            <Header as="h4">Dokazi</Header>
                            <Table basic="very" compact celled>
                                <Table.Body>
                                    <Table.Row>
                                        <Table.Cell textAlign="right" style={{ fontWeight: 'bold' }}>Dokazi o
                                            vlasništvu</Table.Cell>
                                        <Table.Cell>{v(prop.ownershipEvidence)}</Table.Cell>
                                    </Table.Row>
                                </Table.Body>
                            </Table>
                        </Segment>

                        {/* Napomene */}
                        <Segment>
                            <Header as="h4">Napomene</Header>
                            <Table basic="very" compact celled>
                                <Table.Body>
                                    <Table.Row>
                                        <Table.Cell textAlign="right"
                                                    style={{ fontWeight: 'bold' }}>Napomene</Table.Cell>
                                        <Table.Cell>{v(prop.notes)}</Table.Cell>
                                    </Table.Row>
                                    <Table.Row>
                                        <Table.Cell textAlign="right" style={{ fontWeight: 'bold' }}>Dodatne
                                            napomene</Table.Cell>
                                        <Table.Cell>{v(prop.additionalNotes)}</Table.Cell>
                                    </Table.Row>
                                </Table.Body>
                            </Table>
                        </Segment>

                    </Grid.Column>
                    <Grid.Column>
                        {/* Zemljišno-knjižni podaci */}
                        <Segment>
                            <Header as="h4">Zemljišno-knjižni podaci</Header>
                            <Table basic="very" compact celled>
                                <Table.Body>
                                    <Table.Row>
                                        <Table.Cell textAlign="right" style={{ fontWeight: 'bold' }}>Površina
                                            (m²)</Table.Cell>
                                        <Table.Cell>{v(prop.landRegistryArea)}</Table.Cell>
                                    </Table.Row>
                                    <Table.Row>
                                        <Table.Cell textAlign="right" style={{ fontWeight: 'bold' }}>Broj katastarskog
                                            uloška</Table.Cell>
                                        <Table.Cell>{v(prop.landRegistryEntryNumber)}</Table.Cell>
                                    </Table.Row>
                                    <Table.Row>
                                        <Table.Cell textAlign="right" style={{ fontWeight: 'bold' }}>Opštinski katastar
                                            (ZK)</Table.Cell>
                                        <Table.Cell>{prop.landRegistryMunicipalCadastre ? prop.landRegistryMunicipalCadastre.name : '-'}</Table.Cell>
                                    </Table.Row>
                                    <Table.Row>
                                        <Table.Cell textAlign="right" style={{ fontWeight: 'bold' }}>Obim prava
                                            (ZK)</Table.Cell>
                                        <Table.Cell>{v(prop.landRegistryRightsScopeNotes)}</Table.Cell>
                                    </Table.Row>
                                    <Table.Row>
                                        <Table.Cell textAlign="right" style={{ fontWeight: 'bold' }}>Tereti</Table.Cell>
                                        <Table.Cell>{v(prop.encumbrances)}</Table.Cell>
                                    </Table.Row>
                                    <Table.Row>
                                        <Table.Cell textAlign="right" style={{ fontWeight: 'bold' }}>B-lista
                                            napomene</Table.Cell>
                                        <Table.Cell>{v(prop.bListNotes)}</Table.Cell>
                                    </Table.Row>
                                </Table.Body>
                            </Table>
                        </Segment>

                        {/* Katastarski/posjedovni podaci */}
                        <Segment>
                            <Header as="h4">Katastarski/posjedovni podaci</Header>
                            <Table basic="very" compact celled>
                                <Table.Body>
                                    <Table.Row>
                                        <Table.Cell textAlign="right" style={{ fontWeight: 'bold' }}>Broj posjedovnog
                                            lista</Table.Cell>
                                        <Table.Cell>{v(prop.possessionSheetNumber)}</Table.Cell>
                                    </Table.Row>
                                    <Table.Row>
                                        <Table.Cell textAlign="right" style={{ fontWeight: 'bold' }}>Opštinski katastar
                                            (KP)</Table.Cell>
                                        <Table.Cell>{prop.possessionMunicipalCadastre ? prop.possessionMunicipalCadastre.name : '-'}</Table.Cell>
                                    </Table.Row>
                                    <Table.Row>
                                        <Table.Cell textAlign="right" style={{ fontWeight: 'bold' }}>Površina
                                            (m²)</Table.Cell>
                                        <Table.Cell>{v(prop.possessionArea)}</Table.Cell>
                                    </Table.Row>
                                    <Table.Row>
                                        <Table.Cell textAlign="right" style={{ fontWeight: 'bold' }}>Obim prava
                                            (KP)</Table.Cell>
                                        <Table.Cell>{v(prop.possessionRightsScopeNotes)}</Table.Cell>
                                    </Table.Row>
                                </Table.Body>
                            </Table>
                        </Segment>

                        {/* Knjigovodstveni podaci */}
                        <Segment>
                            <Header as="h4">Knjigovodstveni podaci</Header>
                            <Table basic="very" compact celled>
                                <Table.Body>
                                    <Table.Row>
                                        <Table.Cell textAlign="right" style={{ fontWeight: 'bold' }}>Nabavna
                                            vrijednost</Table.Cell>
                                        <Table.Cell>{v(prop.acquisitionValue)}</Table.Cell>
                                    </Table.Row>
                                    <Table.Row>
                                        <Table.Cell textAlign="right"
                                                    style={{ fontWeight: 'bold' }}>Valorizacija</Table.Cell>
                                        <Table.Cell>{v(prop.valueAdjustment)}</Table.Cell>
                                    </Table.Row>
                                    <Table.Row>
                                        <Table.Cell textAlign="right" style={{ fontWeight: 'bold' }}>Knjigovodstvena
                                            vrijednost</Table.Cell>
                                        <Table.Cell>{v(prop.bookValue)}</Table.Cell>
                                    </Table.Row>
                                    <Table.Row>
                                        <Table.Cell textAlign="right" style={{ fontWeight: 'bold' }}>Obim prava
                                            (zajednička ulaganja)</Table.Cell>
                                        <Table.Cell>{v(prop.jointInvestmentRightsScopeNotes)}</Table.Cell>
                                    </Table.Row>
                                </Table.Body>
                            </Table>
                        </Segment>
                    </Grid.Column>
                </Grid>;
            </div>
        );
    }
}

export default Info;



// WEBPACK FOOTER //
// ./src/views/Assets/Property/Details/Info.js